import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiEmptyDefaultComponent } from "./components/default/default.component";
import { UiEmbedEmptyComponent } from "./components/embed-empty/embed-empty.component";
import { UiEmptySimpleComponent } from "./components/simple/simple.component";
import { UiEmptyComponent } from "./empty.component";

@NgModule({
  imports: [CommonModule, NzOutletModule, PortalModule],
  declarations: [UiEmptyComponent, UiEmptyDefaultComponent, UiEmptySimpleComponent, UiEmbedEmptyComponent],
  exports: [UiEmptyComponent, UiEmptyDefaultComponent, UiEmptySimpleComponent, UiEmbedEmptyComponent],
})
export class UiEmptyModule {}
